export const RUSSIAN_PHONE_PATTERN = String.raw`\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}`;
export const EMAIL_INPUT_PATTERN = String.raw`[^\s@]+@[^\s@]+\.[^\s@]{2,}`;

const RUSSIAN_PHONE_RE = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function formatRussianPhone(value: string): string {
  const digits = value.replace(/\D/g, '');
  let local = digits;

  if (local.startsWith('7') || local.startsWith('8')) {
    local = local.slice(1);
  }

  local = local.slice(0, 10);
  if (!local) return '';

  let result = '+7';
  if (local.length > 0) result += ` (${local.slice(0, 3)}`;
  if (local.length >= 3) result += ')';
  if (local.length > 3) result += ` ${local.slice(3, 6)}`;
  if (local.length > 6) result += `-${local.slice(6, 8)}`;
  if (local.length > 8) result += `-${local.slice(8, 10)}`;
  return result;
}

export function isValidRussianPhone(value: string): boolean {
  return RUSSIAN_PHONE_RE.test(value.trim());
}

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

